import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex);
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

const store = new Vuex.Store({
    state: {
        auth: {
            id: '',
            usuario: '',
            rol: {
                id: '',
                nombre: '',
            },
            email: '',
            avatar: '',
            nombre: '',
            persona: {},
            areas: [],
            permisos: [],
            permisoActual: '',
            permisoActualTexto: '',
            areaActual: '',
            areaActualTexto: '',

        },
        tipoCambio:{
            compra: 0,
            venta: 0,
        },
        parametros: null,
    },
    mutations: {
        setAuthUserDetail(state, auth) {
            for (let key of Object.keys(auth)) {
                state.auth[key] = auth[key];
            }
            if ('avatar' in auth)
                state.auth.avatar = auth.avatar !== null ? auth.avatar : 'avatar.png';
        },
        resetAuthUserDetail(state) {
            for (let key of Object.keys(state.auth)) {
                state.auth[key] = '';
            }
        },
        setParametros(state, parametros) {
            for (let key of Object.keys(parametros)) {
                state.parametros[key] = parametros[key];
            }
        },
        resetParametros(state) {
            for (let key of Object.keys(state.parametros)) {
                state.parametros[key] = '';
            }
        },
        setTipoCambio(state, tipoCambio) {
            for (let key of Object.keys(tipoCambio)) {
                state.tipoCambio[key] = tipoCambio[key];
            }
        },
        resetTipoCambio(state) {
            for (let key of Object.keys(state.tipoCambio)) {
                state.tipoCambio[key] = '';
            }
        },
    },
    actions: {
        setAuthUserDetail({ commit }, auth) {
            commit('setAuthUserDetail', auth);
        },
        resetAuthUserDetail({ commit }) {
            commit('resetAuthUserDetail');
        },
        setParametros({ commit }, parametros) {
            commit('setParametros', parametros);
        },
        resetParametros({ commit }) {
            commit('resetParametros');
        },
        setTipoCambio({ commit }, parametros) {
            commit('setTipoCambio', parametros);
        },
        resetTipoCambio({ commit }) {
            commit('resetTipoCambio');
        },
    },
    getters: {
        getAuthUser: (state) => (name) => {
            return state.auth[name];
        },
        getAuthUserName: (state) => {
            return state.auth.nombre;
        },
        getRol: (state) => {
            return state.auth.rol.id;
        },
        getAreas: (state) => {
            return state.auth.areas;
        },
        getAreaActual: (state) => {
            return state.auth.areaActual;
        },
        getPermisos: (state) => {
            return state.auth.permisos;
        },
        getPermisoActual: (state) => {
            return state.auth.permisoActual;
        },
        getTipoCambio: (state) => (name) => {
            return state.tipoCambio[name];
        },
    },
    plugins: [
        createPersistedState({ storage: window.sessionStorage })
    ]
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js